import { useTranslation } from "react-i18next";
import type { Featured } from "./CasesContent";
import CaseImage from "./CaseImage";
import CaseStats from "./CaseStats";
import CaseTechs from "./CaseTechs";
import { useInView } from "../../util/useInView";

// entrega em blocos no lugar do desafio. Os números contam e os blocos entram em cascata quando o painel aparece.
export default function CaseFeatured({ id, featured }: { id: string; featured: Featured }) {
  const { t } = useTranslation();
  const [ref, state] = useInView<HTMLElement>(0.15);
  const offset = featured.stats.length;

  return (
    <section className="cz-cases-section" id={id} aria-labelledby={`${id}-title`}>
      <div className="cz-cases-section__inner">
        <article ref={ref} className={`cz-case-panel cz-case-panel--featured${state}`}>
          <header className="cz-case-panel__head">
            <div className="cz-case-panel__lead">
              <span className="cz-case-panel__badge" aria-hidden="true">
                <featured.Icon size={30} strokeWidth={1.6} />
              </span>
              <div className="cz-case-panel__heading">
                <span className="cz-eyebrow">{t("cases_page.labels.featured_eyebrow", "Case em destaque")}</span>
                <h2 className="cz-cases-title" id={`${id}-title`}>
                  {featured.title}
                </h2>
                <p className="cz-cases-subtitle">{featured.text}</p>
              </div>
            </div>
            <div className="cz-case-panel__logos">
              <CaseImage src={featured.logo.src} alt={featured.logo.alt} className="cz-case-panel__logo cz-case-panel__logo--goias" />
            </div>
          </header>

          <CaseStats results={featured.stats} state={state} />

          <div className="cz-case-panel__section">
            <span className="cz-case-label">{featured.itemsLabel}</span>
            <ul className="cz-case-panel__tiles">
              {featured.items.map(({ Icon, title, text }, i) => (
                <li
                  key={title}
                  className="cz-case-panel__tile"
                  data-reveal
                  style={{ "--i": offset + i } as React.CSSProperties}
                >
                  <span className="cz-case-panel__tile-icon" aria-hidden="true">
                    <Icon size={20} strokeWidth={1.8} />
                  </span>
                  <strong className="cz-case-panel__tile-title">{title}</strong>
                  <span className="cz-case-panel__tile-text">{text}</span>
                </li>
              ))}
            </ul>
          </div>

          <footer className="cz-case-panel__foot">
            <CaseTechs techs={featured.techs} />
          </footer>
        </article>
      </div>
    </section>
  );
}
